/**
 * sl-9qm.10.3: Register Widget Components
 *
 * Called during StreamLain module initialization to register
 * widget components (Form, etc.) in the ComponentRegistry.
 */
import type { ComponentRegistry } from '../../services/component-registry';
import { FormViewComponent } from './widget/form-view';

export function registerWidgetComponents(registry: ComponentRegistry): void {
  registry.register(FormViewComponent);
}
